import React from 'react';

import styles from './LiveIndicator.css';

export default () => <span className={styles.dot} data-test="live-indicator" />;
